'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import { featureFlags } from '@/lib/env';

/**
 * 行政申請（e-Gov 申請）UI モックの pathless まとめルート + フラグゲート。
 *
 * パスなしレイアウトのため URL には現れず、配下は `/labor-core/egov-application` として
 * 提供される。他の労務コアモックと揃えて `LABOR_PLUS_MOCK` が有効なテナントでのみ表示し、
 * 既定は OFF のため本番・フラグ未設定の環境では 404（NotFound）になり、既存の行政申請画面
 * （government-application-confirmation）には一切影響しない。
 * モックのため、本番化・不要時はこの `_egov-mock` サブツリーごと削除できる。
 */
export const Route = createFileRoute('/_staff/labor-core/_egov-mock')({
  component: EgovMockLayout
});
function EgovMockLayout() {
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <Outlet />;
}